import type { AuthUser } from '@/features/signin/domains/auth_user'
import { defineStore } from 'pinia'
import { StorageEnum } from '../enums/storage.enum'
import { CLEAR_STORE, GET_STORAGE, SET_STORAGE } from '../utils/storage'
import { authService } from './../../features/signin/application/services/auth_service'

export const userStore = defineStore('authentication', {
  state: () => {
    return {
      user: null as AuthUser | null,
      token: '',
      loading: false,
      error: '',
      init: false,
      initPromise: null as Promise<void> | null,
    }
  },
  getters: {
    isAuthenticated(state) {
      return !!state.user
    },
    userAuthenticated(state) {
      return state.user
    },
    tokenUser(state) {
      return state.token
    },
    isInitialized(state) {
      return state.init
    },
  },
  actions: {
    // NUEVA ACCIÓN: Inicializar sincrónicamente desde localStorage
    initializeFromStorage() {
      if (this.init) return // Ya está inicializado

      const getToken = GET_STORAGE(StorageEnum.TOKEN)
      const getUser = GET_STORAGE(StorageEnum.USER)

      if (getToken && getUser) {
        try {
          const token = atob(getToken)
          const user = JSON.parse(atob(getUser))
          this.$patch({ user, token, init: true })
        } catch (error) {
          console.error('Error al inicializar desde storage:', error)
          this.init = true
        }
      } else {
        this.init = true
      }
    },

    async signin(payload: { email: string; password: string }) {
      this.loading = true
      const resp = await authService.login(payload)
      if (resp && resp.STATUS_CODE == 1) {
        const userMapped = resp.DATA!.user
        const token = resp.DATA!.accessToken
        SET_STORAGE(StorageEnum.USER, btoa(JSON.stringify(userMapped)))
        SET_STORAGE(StorageEnum.TOKEN, btoa(token))
        this.$patch({ user: userMapped, token: token, init: true })
        this.loading = false
      } else {
        this.$patch({ user: null, token: '', init: false })
        this.error = resp.ERROR!.message
        this.loading = false
      }
    },

    async me(token: string) {
      this.loading = true
      const resp = await authService.me(token)
      if (resp && resp.STATUS_CODE == 1) {
        const userMapped = resp.DATA!
        SET_STORAGE(StorageEnum.USER, btoa(JSON.stringify(userMapped)))
        const getToken = GET_STORAGE(StorageEnum.TOKEN)
        let token = ''
        if (getToken) {
          token = atob(getToken)
        }
        this.$patch({ user: userMapped, token: token, init: true })
        this.loading = false
      } else {
        this.$patch({ user: null, token: '', init: true }) // Cambiar a true
        this.error = resp.ERROR!.message
        this.loading = false
      }
    },

    async loadUser() {
      const getToken = GET_STORAGE(StorageEnum.TOKEN)
      if (getToken) {
        const decode = atob(getToken)
        await this.me(decode)
      } else {
        this.init = true
      }
    },

    // MODIFICAR: ensureInitialized ahora solo garantiza init desde storage
    ensureInitialized() {
      if (!this.init) {
        this.initializeFromStorage()
      }
    },

    // NUEVA: Validar token con el backend (llamar después del guard)
    async validateToken() {
      if (this.token) {
        await this.me(this.token)
      }
    },

    async logout() {
      await authService.logout()
      this.$reset()
      CLEAR_STORE()
    },

    clear() {
      this.loading = false
      this.error = ''
    },
  },
})
